import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { cryptoWaitReady, mnemonicGenerate } from "@polkadot/util-crypto";
import keyring from "@polkadot/ui-keyring";
import { useDispatch } from "react-redux";
import { setPopupMessage } from "../../../redux/popupMessage";
import { setAccount } from "../../../redux/account";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import routes from "../../../constants/routes";
import { Keyring as Keyring2 } from "@polkadot/keyring";

const Connect = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [mnemonic, setMnemonic] = useState(null);

    const { account } = useSelector((state) => state?.account);

    useEffect(() => {
        if (account) {
            history(routes?.dashboard);
        }
        createMnemonic();
    }, [account]);

    const createMnemonic = () => {
        const mnemonic = mnemonicGenerate(12);
        setMnemonic(mnemonic);
    };

    const initAccount = () => {
        // add the account, encrypt the stored JSON with an account-specific password
        try {
            const { pair, json } = keyring.addUri(mnemonic, "password", {
                name: "account",
            });

            dispatch(setAccount({ account: json, mnemonic }));
        } catch (error) {
            dispatch(setPopupMessage("Invalid MNEMONIC PHRASE"));
        }
    };

    const handleCopy = () => {
        var copyText = document.getElementById("mnemonic");
        copyText.select();
        copyText.setSelectionRange(0, 99999); /* For mobile devices */
        navigator.clipboard.writeText(copyText.value);
        dispatch(setPopupMessage("Copied"));
    };

    return (
        <div className="pages-connect">
            <div className="box">
                <div className="title">{t("connect.MNEMONIC PHRASE")}</div>
                <div className="description">
                    {t("connect.Your 12 Mnemonic Phrase")}
                </div>
                <textarea
                    className="text"
                    defaultValue={mnemonic}
                    id="mnemonic"
                    onChange={(e) => setMnemonic(e?.target?.value)}
                />
                <div className="actions">
                    <div className="action g-buttonHover" onClick={handleCopy}>
                        {t("connect.Copy")}
                        <img src="/images/copy.svg" alt="" />
                    </div>
                    <div
                        className="action g-buttonHover"
                        onClick={createMnemonic}
                    >
                        {t("connect.Change phrase")}
                        <img src="/images/change.svg" alt="" />
                    </div>
                </div>
                <div
                    className="notice"
                    dangerouslySetInnerHTML={{
                        __html: t(
                            "connect.Please make sure you <span>WRITE DOWN </span> and <span>SAVE</span> your mnemonic phrase. You will need it to access your wallet."
                        ),
                    }}
                ></div>
                <div className="buttons">
                    <div className="back g-buttonHover">
                        {t("connect.Back")}
                    </div>
                    <div className="create g-buttonHover" onClick={initAccount}>
                        {t("connect.Create Wallet")}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Connect;
